export default __webpack_public_path__ + "static/media/ic_wbtc_24.5dda0ca3.svg";